// This is a workaround to avoid console.log in production
console._log = console.log as any;
if (import.meta.env.PROD) console._log = () => {};
